module.exports = __webpack_public_path__ + "img/female-youngadult-head.cc118387.svg";